import { Component, Inject, Injector, OnInit, PLATFORM_ID } from '@angular/core';
import { FormDataService } from '../Services/form-data.services';
import { Asegurado } from '../Models/asegurado-detalle';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { ApiService } from '../Services/api.services';
import { AppInsightsService } from '../Services/appInsight.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css'],
})
export class LandingComponent implements OnInit {
  asegurado: Asegurado;

  constructor(private formDataService: FormDataService,
              private router: Router,
              @Inject(PLATFORM_ID) private platformId: any,
              private activatedRoute: ActivatedRoute,
              private apiService: ApiService,
              private inj: Injector) {
    this.asegurado = formDataService.asegurado;
  }

  ngOnInit(): void{
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('asegurado');
    }
    this.activatedRoute.queryParams.subscribe(params => {
      const guid = params['guid'];
      if (guid && guid !== '') {
        this.authenticateUser(guid);
      }
    });
  }

  public handleOfferErrorTechniques(error: any): void {
    console.log('no offer for you, sorry', error);
    this.router.navigate(['/errortechniques']);
  }
  private authenticateUser(guid: string): void{
    this.apiService.AuthenticateUser(guid).subscribe((response: any) => {
      this.asegurado.Rut = response.rut;
      this.asegurado.UserId = response.userId;
      this.asegurado.Nombre = response.nombre;
      this.asegurado.Apellido = response.apellido;
      this.obtainCarPolicy(this.asegurado.Rut);
      localStorage.setItem('asegurado', JSON.stringify(this.asegurado));
    }, error => {
      const appInsightService = this.inj.get(AppInsightsService);
      appInsightService.logException(error);
      this.handleOfferErrorTechniques(error);
    });
  }

  private obtainCarPolicy(rut: string): void{
    this.apiService.getAutos(rut).subscribe((data: any) => {
      let autos = data;
      localStorage.setItem('firstInsurancePolicy', autos[0].idPoliza);
      localStorage.setItem('firstIdVoucher', autos[0].idVoucher);
      localStorage.setItem('firstUrlImgInsurance', autos[0].idAseguradora);
      localStorage.setItem('dataSelectAutos', JSON.stringify(autos));
      this.asegurado.Sucursal = autos[0].sucursal;
      localStorage.removeItem('miSeguro');
      this.router.navigate(['/seguro']);
    }, error => {
      const appInsightService = this.inj.get(AppInsightsService);
      appInsightService.logException(error);
      this.handleOfferErrorTechniques(error);
    });
  }
}
